<template>
  <BaseInnerLoading v-if="isLoadingAuthStatus" />
  <div
    v-else-if="hasRetrieveSelfUserFailed"
    class="flex min-h-screen items-center justify-center p-4"
  >
    <BaseCard class="w-full max-w-sm p-8 text-center">
      <IconExclamationTriangle
        class="mx-auto mb-4 size-16 text-primary"
      />
      <h1
        class="mb-2 text-2xl font-semibold text-background-fg/87"
      >
        Oops! Something went wrong.
      </h1>

      <p class="mb-6 text-background-fg/60">
        We’re having trouble loading this page. Please try
        again.
      </p>

      <ButtonPrimary @click="() => refetchSelfUser()">
        Retry
      </ButtonPrimary>
    </BaseCard>
  </div>
  <RouterView v-else />
</template>

<script setup lang="ts">
import { api } from "@/services/api"
import { useHead } from "@unhead/vue"
import ButtonPrimary from "./components/ButtonPrimary.vue"
const {
  isLoggedIn,
  isLoadingAuthStatus,
  refetchSelfUser,
  hasRetrieveSelfUserFailed,
} = useAuth()
const { pageTitle } = usePageTitle()
const router = useRouter()
const route = useRoute()
useHead({
  title: pageTitle,
  titleTemplate: (title: string | undefined) =>
    title
      ? `Takepayments+ Control | ${title}`
      : `Takepayments+ Control`,
})
onMounted(() => {
  api.get("/get-csrf-token/")
})

// Add routes that don't require authentication
const publicRoutes = [
  "login",
  "passwordResetRequest",
  "resetPassword",
]

whenever(
  () =>
    !isLoadingAuthStatus.value &&
    !isLoggedIn.value &&
    !publicRoutes.includes(route.name),
  () => {
    router.push({ name: "login" })
  },
  { immediate: true }
)
</script>

<style lang="scss">
input[type="number"] {
  appearance: textfield;
  margin: 0;
}

input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
}
</style>
